﻿import $ from "jquery";
import "bootstrap";
import { GuiDetailAktion } from "./GuiDetailAktion";

export class GuiDetailBestellungAktion extends GuiDetailAktion {

    constructor() {
        super();
    }

    override attachEvents() {
        super.attachEvents();
    }

    protected override getUrlParameter(): string {
        const bestellungId = $("#BestellungId").val() as string;
        return `bestellungId=${bestellungId}`;
    }
   
}
